
import { defineComponent, PropType } from "vue";
import { RouterLink } from "vue-router";

import { categoryName, subCategoryName } from "../data/query";
import { Listing } from "../data/types";
import { displayViews } from "../store/preferences";
import common from "../styles/common.module.less";
import CoverThumb from "./cover-thumb.vue";
import { Icon } from "./icons";
import StatusBadge from "./status-badge.vue";

export default defineComponent({
  name: "XiyouListingCard",
  props: {
    listing: { type: Object as PropType<Listing>, required: true },
  },
  setup(props) {
    return () => {
      const item = props.listing;
      const label =
        subCategoryName(item.category, item.subCategory) ||
        categoryName(item.category);
      const publisher =
        item.publisherType === "merchant"
          ? item.companyName || "商家发布"
          : "个人发布";
      return (
        <RouterLink
          class={common.card}
          to={{ name: "XiyouDetail", params: { id: String(item.id) } }}
        >
          <CoverThumb id={item.id} label={label} />
          <div class={common.cardBody}>
            <div class={common.badgeRow}>
              {item.top ? <StatusBadge text="置顶" tone="top" /> : null}
              {item.recommend ? (
                <StatusBadge text="推荐" tone="recommend" />
              ) : null}
              <StatusBadge text={categoryName(item.category)} tone="plain" />
              <StatusBadge
                text={
                  item.publisherType === "merchant" ? "商家发布" : "个人发布"
                }
                tone={item.publisherType}
              />
            </div>
            <div class={common.cardTitle}>{item.title}</div>
            <div class={common.cardSummary}>{item.summary}</div>
            <div class={common.publisher}>
              <span>{publisher}</span>
              <span>{item.publishedAt}</span>
            </div>
            <div class={common.cardFooter}>
              <span class={common.cardMetaItem}>
                <Icon name="eye" />
                {displayViews(item.views, item.id)}
              </span>
              <span class={common.price}>{item.price}</span>
            </div>
          </div>
        </RouterLink>
      );
    };
  },
});
